import { FastlyImage } from '@components/common/image'
import Logo from '@components/common/logo'

type Props = {
  partnerLogo?: string
  logoImageProperties?: {
    width?: number
    height?: number
    alt?: string
  }
  partnerLink?: string
}

const CodingalPartnerLogo = ({
  partnerLogo,
  logoImageProperties,
  partnerLink,
}: Props) => {
  return (
    <div className="flex items-baseline gap-x-5 lg:gap-x-10 p-4 lg:p-0">
      <div>
        <Logo
          withText
          className="h-8 lg:w-40 mt-2 lg:-mt-5 lg:h-12 lg:ml-20 mx-auto"
          alt="Codingal logo"
        />
      </div>
      <span className="h-10 bg-grey-500" style={{ width: '2px' }} />
      {!partnerLink && (
        <FastlyImage
          priority
          src={partnerLogo}
          height={logoImageProperties.height}
          width={logoImageProperties.width}
          alt={logoImageProperties.alt}
        />
      )}
      {partnerLink && (
        <a href={partnerLink} target="_blank noreferrer">
          <FastlyImage
            priority
            src={partnerLogo}
            height={logoImageProperties.height}
            width={logoImageProperties.width}
            alt={logoImageProperties.alt}
          />
        </a>
      )}
    </div>
  )
}

export default CodingalPartnerLogo
